/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Manager_Min_Duration_LabelInputs */

const en_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimum Event Duration (in seconds)`)
};

const fr_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duree minimale d'evenement (en secondes)`)
};

const de_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Minimale Ereignisdauer (in Sekunden)`)
};

const it_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Durata minima dell'evento (in secondi)`)
};

const ru_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Минимальная продолжительность события (в секундах)`)
};

const es_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duración mínima del evento (en segundos)`)
};

const zh_cn2_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最短事件持续时间（秒）`)
};

const ja_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最小イベント継続時間（秒）`)
};

const hi_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`न्यूनतम आयोजन अवधि (सेकंड में)`)
};

const pt_pt2_style_guide_manager_min_duration_label = /** @type {(inputs: Style_Guide_Manager_Min_Duration_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Duração mínima do evento (em segundos)`)
};

/**
* | output |
* | --- |
* | "Minimum Event Duration (in seconds)" |
*
* @param {Style_Guide_Manager_Min_Duration_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_manager_min_duration_label = /** @type {((inputs?: Style_Guide_Manager_Min_Duration_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Manager_Min_Duration_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_manager_min_duration_label(inputs)
	if (locale === "de") return de_style_guide_manager_min_duration_label(inputs)
	if (locale === "it") return it_style_guide_manager_min_duration_label(inputs)
	if (locale === "ru") return ru_style_guide_manager_min_duration_label(inputs)
	if (locale === "es") return es_style_guide_manager_min_duration_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_manager_min_duration_label(inputs)
	if (locale === "ja") return ja_style_guide_manager_min_duration_label(inputs)
	if (locale === "hi") return hi_style_guide_manager_min_duration_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_manager_min_duration_label(inputs)
	return en_style_guide_manager_min_duration_label(inputs)
});